export default __webpack_public_path__ + "static/media/topography.fee9c91f.svg";